import { render, staticRenderFns } from "./PreventivasDetalleGrid.vue?vue&type=template&id=5fad0da3&"
import script from "./PreventivasDetalleGrid.vue?vue&type=script&lang=ts&"
export * from "./PreventivasDetalleGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports